export default __webpack_public_path__ + "static/sports-mint-7ee9f1cd320f5cb45e5ab6bda92f1297.png";